import Diagram from '../common/Diagram';
import { DiagramDatabase } from '../parsing/DiagramStructure';
import { randomId } from './utils';
import { type WhiteboardData, type LayoutOptions } from '../types';

// Diagram that is returned when parsing completely fails.
class ErrorDiagram extends Diagram {
  _width: number;
  _height: number;

  constructor({ width, height }: { width: number; height: number }) {
    super(new DiagramDatabase());

    this._width = width;
    this._height = height;
  }

  width() {
    return this._width;
  }

  height() {
    return this._height;
  }

  isError() {
    return true;
  }

  async layout(_layoutOptions: LayoutOptions) {}

  renderToWhiteboard(): any {
    const whiteboard: WhiteboardData = {
      version: '1.2.6',
      objects: {},
    };
    const id = randomId();

    const shapeWidth = 200;
    const shapeHeight = 60;
    whiteboard.objects[id] = {
      type: 'shape',
      shapeName: 'roundRect',
      id: id,
      left: this.width() / 2 - shapeWidth / 2,
      top: this.height() / 2 - shapeHeight / 2,
      width: shapeWidth,
      height: shapeHeight,
      scaleX: 1,
      scaleY: 1,
      textContent: `<p><span style="color:#b82b2b">Unable to generate diagram</span></p>`,
      fill: '#ffdbdb',
      stroke: '#b82b2b',
      strokeWidth: 3,
    };

    return whiteboard;
  }
}

export default ErrorDiagram;
